import { render, staticRenderFns } from "./RechargeWay.vue?vue&type=template&id=8c0726ca&scoped=true&"
import script from "./RechargeWay.vue?vue&type=script&lang=js&"
export * from "./RechargeWay.vue?vue&type=script&lang=js&"
import style0 from "./RechargeWay.vue?vue&type=style&index=0&id=8c0726ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0726ca",
  null
  
)

export default component.exports